import { render, staticRenderFns } from "./ListTrksPage.vue?vue&type=template&id=5faf8639"
import script from "./ListTrksPage.vue?vue&type=script&lang=js"
export * from "./ListTrksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports